// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__1JmZw","emails":"CreateEditClinics_emails__22cco","emailTagLabel":"CreateEditClinics_emailTagLabel__1Mrvi"};